import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import userManager from "../utils/user-manager";

const Login = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirectTo = params.get("redirectTo");

    if (redirectTo) userManager.signinRedirect({ state: { redirectTo } });
    else userManager.signinRedirect();
  }, [location]);

  return (
    <div className="section-content-wrapper">
      <Container fluid className="p-5" style={{ margin: "5rem auto" }}>
        Redirecting to login page...
      </Container>
    </div>
  );
};

export default Login;
